import LogoutIcon from "@mui/icons-material/Logout";
import { observer } from "mobx-react";
import { useUser } from "providers/UserProvider";
import { ReactComponent as UnocrmLogo } from "assets/icons/ic-unocrm-logo.svg";
import { useSimpleRegistration } from "~/hooks/useStore";
import { Box, IconButton } from "./TopSection.styled";
import { useAuth } from "providers/AuthProvider";

export const TopSection = observer(() => {
  const { getHiddenCondition } = useSimpleRegistration();
  const { user } = useUser();
  const { signout } = useAuth();

  const handleClick = () => {
    signout();
  };

  return (
    <Box className="top-wrapper">
      <Box className="background-image-wrapper">
        <Box className="title-wrapper">
          {getHiddenCondition ? (
            <IconButton onClick={handleClick}>
              <LogoutIcon />
            </IconButton>
          ) : (
            user.organization_top.name
          )}
          <UnocrmLogo />
        </Box>
        <Box className="description-wrapper">
          <p className="description font-size-5vw">
            반갑습니다 {getHiddenCondition ? "🤫" : ";)"} <br />
          </p>
          <p className="description font-size-3vw">
            전화번호로 접수를 시작합니다.
          </p>
        </Box>
      </Box>
    </Box>
  );
});
